(ns minorodata.components.data-apps.dashboard-iframe
  (:require ["lucide-react" :refer [ArrowLeft Frown LineChart]]
            [minorodata.app.handlers :refer [dispatch]]
            [minorodata.components.spinner.core :as c.spinner]
            [re-posh.core :as re-posh]
            [reitit.frontend.easy :as rt.easy]
            [ui.button :refer [button]]
            [ui.typography :refer [h1 p]]))

(defn dashboard-unavailable []
  [:div {:class "flex flex-col items-center gap-6 my-16 text-center"}
   [:> Frown {:size 52}]

   [:div
    [h1 "Dashboard unavailable"]
    [p {:class "text-kleene-text-secondary"} "Please contact support."]]

   [:footer
    [button {:href (rt.easy/href :data-apps)
             :icon ArrowLeft}
     "Go back"]]])

(defn dashboard-iframe [{:keys [sigma-id sigma-url userbacked hide-menu workbook]}]
  (when (and sigma-id sigma-url)
    (if userbacked
      (dispatch [:health.api/fetch-dashboard-userbacked-url sigma-id sigma-url {:hide-menu hide-menu :workbook workbook}])
      (dispatch [:health.api/fetch-dashboard-url sigma-id sigma-url {:hide-menu hide-menu}])))

  (fn [{:keys [sigma-id sigma-url]}]
    (let [url-loading? @(re-posh/subscribe [:mold-http/loading? :health.api/fetch-dashboard-url])

          custom-dashboards-loading? @(re-posh/subscribe [:mold-http/loading? :data-apps.api/fetch-all])

          loading? (or custom-dashboards-loading? url-loading?)

          {:keys [status signed-url]} @(re-posh/subscribe [:health.subs/dashboard-url sigma-id])]

      [:div {:class "w-full" :key sigma-url}
       (cond

         loading?
         [:div {:class "relative text-center"}
          [c.spinner/spinner-lucide {:size 50}]]


         (nil? sigma-id)
         [:div {:class "text-center flex flex-col h-full items-center justify-center"}
          [:> LineChart {:size 52}]
          [h1 "Dashboard does not exist"]

          [:footer {:class "mt-6"}
           [button {:href (rt.easy/href :data-apps)
                    :icon ArrowLeft}
            "Go back"]]]

         (= :failure status)
         [:div {:class "text-center flex flex-col h-full items-center justify-center"}
          [:> Frown  {:size 52}]
          [h1 "Failed to load the dashboard"]

          [:footer {:class "mt-6"}
           [button {:href (rt.easy/href :data-apps)
                    :icon ArrowLeft}
            "Go back"]]]


         (some? signed-url)
         [:iframe {:src         signed-url
                   :height      "100%"
                   :width       "100%"
                   :frame-border 0
                   :class        "align-top"}]

         :else
         [dashboard-unavailable])])))
